import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Feminine%20fitness%20aesthetic%20background%20with%20soft%20gradient%20from%20warm%20cream%20to%20peach%20tones%2C%20abstract%20flowing%20organic%20shapes%2C%20minimalist%20artistic%20composition%2C%20elegant%20curved%20lines%2C%20subtle%20texture%2C%20high%20key%20bright%20photography%20style%2C%20warm%20natural%20light%2C%20clean%20and%20modern%20design%20aesthetic&width=1800&height=1200&seq=hero-bg-01&orientation=landscape"
          alt="蜜桃臀塑形指南背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-6 tracking-wider uppercase font-label">
            科学训练 · 专业塑形
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            科学打造完美
            <span className="block text-primary-300">蜜桃臀曲线</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇集专业臀部塑形训练方案、饮食营养建议与常见误区解析，
            帮助你科学高效地打造饱满圆润、线条优美的蜜桃臀，适合居家与健身房双场景。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/training-moves"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
            >
              开始训练
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/diet-nutrition"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 text-background-50 font-medium rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap text-sm"
            >
              饮食指南
              <i className="ri-restaurant-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center">
          <div className="w-1.5 h-3 bg-background-50/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}